module.exports = __webpack_public_path__ + "src/asset/svg/title/about2.svg?3e136c4e8efb3c39f0f01fcf1f84393f";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/title/about2.svg
// module id = 93
// module chunks = 0